module.exports = __webpack_public_path__ + "img/twitter.38339eeb.jpg";